import { PlayerHoldings } from "./PlayerHoldings"
import "../styles/PerPlayerStockData.css"

export const PerPlayerStockData = ({ allPlayerInfo, size }) => {
    return (<div className={`per-player-stock-container-${size}`}>
        {allPlayerInfo.map((player, index) => {
           return (
               <PlayerHoldings key={`player_holdings_${index}`} player={player} size={size}/>
           )
        })}
    </div>)
}